import SeoJsonLd from "../../components/feature/SeoJsonLd";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import PainPoints from "./components/PainPoints";
import AboutKuu from "./components/AboutKuu";
import WhyKuu from "./components/WhyKuu";
import Menu from "./components/Menu";
import OnlineStore from "./components/OnlineStore";
import FirstTimers from "./components/FirstTimers";
import TargetAudience from "./components/TargetAudience";
import Therapist from "./components/Therapist";
import FAQ from "./components/FAQ";
import Cta from "./components/Cta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="font-sans antialiased">
      <SeoJsonLd />
      <Navbar />
      <Hero />
      <PainPoints />
      <AboutKuu />
      <WhyKuu />
      <Menu />
      <OnlineStore />
      <FirstTimers />
      <TargetAudience />
      <Therapist />
      <FAQ />
      <Cta />
      <Footer />
    </div>
  );
}
